import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { useSelector } from "react-redux";
import { auth } from "../Services/FirebaseService";
import { getActiveBrandConfig } from "../config/environment.config";

/**
 * Espace client : garde des routes /user/*.
 * Réservées aux clients authentifiés : un visiteur non connecté est renvoyé
 * vers la page de connexion, un professeur vers son propre tableau de bord.
 */
const ClientRoute = ({ children }: { children: React.ReactElement }) => {
    const currentUser = useSelector((state: any) => state.user.currentUser);
    const [user, loadingAuth] = useAuthState(auth);
    const navigate = useNavigate();

    useEffect(() => {
        // on attend la restauration de la session Firebase avant de décider
        if (loadingAuth) return;

        if (!user || !currentUser?.isAuthenticated) {
            navigate("/");
            return;
        }
        if (currentUser?.isTeachr) {
            navigate(`/${getActiveBrandConfig()}/tableau-de-bord`);
        }
    }, [loadingAuth, user, currentUser, navigate]);

    return children;
};

export default ClientRoute;
